import { types, actions } from './requests'
export const GETPACKAGELIST_TYPES = {
    ...types('GETPACKAGELIST'),
}
export const GETPACKAGELIST_ACTIONS = {
    ...actions('GETPACKAGELIST'),
}